import Text from "@pathwright/ui/src/components/ui/Text"
import Link from "@pathwright/ux/src/components/link/Link"
import styled from "styled-components"
import { PathItemFragment } from "@pathwright/graphql-client/src/generated"
import PWAdminHint from "../../pw-admin/PWAdminHint"
import { getLessonUrl } from "../../utils/urls"
import ReportActions from "./ReportActions"

const Container = styled.div`
  padding: 5px 10px;
  border-radius: 10px;
  text-align: center;
  &:last-child {
    margin-bottom: 0;
  }

  > div:first-child {
    display: flex;
  }
`

const Lesson = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .ReportActions {
    position: absolute !important;
    top: 0;
    right: 0;
  }

  html.no-touch &:not(:hover) .ReportActions i.pathicon-ellipses-horizontal {
    visibility: hidden;
  }
`

const ReportPathGroup = ({
  pathItem,
  includeLink = false
}: {
  pathItem: PathItemFragment
  includeLink?: boolean
}) => {
  const { resource_id: resourceId, cohort_id: cohortId } =
    pathItem.context || {}
  const lessonUrl =
    includeLink && resourceId && cohortId
      ? getLessonUrl(String(resourceId), cohortId, pathItem.source_id)
      : null

  return (
    <PWAdminHint model={pathItem} portal>
      <Container>
        <Lesson>
          {lessonUrl ? (
            <Link to={lessonUrl} variant="plain">
              <Text.H5>{pathItem.name}</Text.H5>
            </Link>
          ) : (
            <Text.H5>{pathItem.name}</Text.H5>
          )}
          <ReportActions pathItem={pathItem} />
        </Lesson>
      </Container>
    </PWAdminHint>
  )
}

ReportPathGroup.displayName = "ReportPathGroup"

export default ReportPathGroup
